import request from "@/plugins/request"

export const getConfigFootList = () => {
  return request({
    url: "app-api/zb/configFoot/list",
    method: "get",
  })
}

export const getArticle = (params) => {
    return request({
      url: "app-api/zb/configFoot/get-article",
      method: "get",
      params,
    })
  }